var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCollapse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.375C1.65482 13.375 1.375 13.6548 1.375 14C1.375 14.3452 1.65482 14.625 2 14.625H13.375V26C13.375 26.3452 13.6548 26.625 14 26.625C14.3452 26.625 14.625 26.3452 14.625 26V14.625H26C26.3452 14.625 26.625 14.3452 26.625 14C26.625 13.6548 26.3452 13.375 26 13.375H14.625V2C14.625 1.65482 14.3452 1.375 14 1.375C13.6548 1.375 13.375 1.65482 13.375 2V13.375H2Z",
    stroke: "#003DA5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCollapse);
export default __webpack_public_path__ + "static/media/plusCollapse.63e0db0100aa1ef8fb2dd76b2706a5a2.svg";
export { ForwardRef as ReactComponent };